import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/WaitingComplete.css";
import Loading from "../imagesProj/Loading.gif";
import { useTranslation } from "react-i18next";


function WaitCompleteScann({ show, onClose }) {
      const { t, i18n } = useTranslation();
  
  return (
    <div className="ModalWrap">
      <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
        <Modal.Header className="modalHeader">
          <Modal.Title className="ModalTitle">Scanner Online</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <img
            width={50}
            height={50}
            src={Loading}
            alt="Loading"
            className="imgLoading"
          />
          <span className="titleImgLoading">
            {t("wait")}
          </span>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default WaitCompleteScann;
